import React from 'react';

/* Common */
import { Button, Image } from '~/components/common';

/* Utilities */
import { getCloudimageUrl } from '~/utilities';

export default function CardArticle({ imgUrl, imgTitle, title, subtitle, url, theme}) {

    return (
        <div className="col-12 col-md-6 col-xl-3">
            <div className="card card--article bg-contrast">
                {imgUrl && (
                    <Image
                        className="card__image card-img-top img-fluid"
                        src={getCloudimageUrl(window.location.host + imgUrl, { w: 540, h: 360, func: 'crop' })}
                        srcSet={`${getCloudimageUrl(window.location.host + imgUrl, { w: 1080, h: 720, func: 'crop' })} 2x`}
                        alt={imgTitle}
                        width={370}
                        height={245}
                        sources={[
                            {
                                set: {
                                    '1x': getCloudimageUrl(window.location.host + imgUrl, { w: 370, h: 245, func: 'crop' }),
                                    '2x': getCloudimageUrl(window.location.host + imgUrl, { w: 740, h: 490, func: 'crop' }),
                                },
                                media: '(min-width: 1660px)',
                            },
                            {
                                set: {
                                    '1x': getCloudimageUrl(window.location.host + imgUrl, { w: 315, h: 210, func: 'crop' }),
                                    '2x': getCloudimageUrl(window.location.host + imgUrl, { w: 630, h: 420, func: 'crop' }),
                                },
                                media: '(min-width: 1440px)',
                            },
                            {
                                set: {
                                    '1x': getCloudimageUrl(window.location.host + imgUrl, { w: 275, h: 183, func: 'crop' }),
                                    '2x': getCloudimageUrl(window.location.host + imgUrl, { w: 550, h: 366, func: 'crop' }),
                                },
                                media: '(min-width: 1280px)',
                            },
                            {
                                set: {
                                    '1x': getCloudimageUrl(window.location.host + imgUrl, { w: 440, h: 293, func: 'crop' }),
                                    '2x': getCloudimageUrl(window.location.host + imgUrl, { w: 880, h: 586, func: 'crop' }),
                                },
                                media: '(min-width: 992px)',
                            },
                            {
                                set: {
                                    '1x': getCloudimageUrl(window.location.host + imgUrl, { w: 320, h: 215, func: 'crop' }),
                                    '2x': getCloudimageUrl(window.location.host + imgUrl, { w: 640, h: 430, func: 'crop' }),
                                },
                                media: '(min-width: 768px)',
                            },
                            {
                                set: {
                                    '1x': getCloudimageUrl(window.location.host + imgUrl, { w: 520, h: 346, func: 'crop' }),
                                    '2x': getCloudimageUrl(window.location.host + imgUrl, { w: 1040, h: 692, func: 'crop' }),
                                },
                                media: '(min-width: 600px)',
                            },
                        ]}
                    />
                )}
                <div className="card-body p-6 p-lg-8">
                    <h6>{title}</h6>
                    <div className="mb-4" dangerouslySetInnerHTML={{ __html: subtitle }} />

                    <div className="mt-auto">
                        <Button
                            className="stretched-link"
                            theme={theme}
                            title="Meer informatie"
                            href={url}
                            showIcon={false}
                            iconSize={14}
                            iconClassName="icon--lg-16"
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}
